module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/es-card-drag.6cae1591b2baee65ce6e.gif";